<template>
	<div>
		<v-dialog v-model="dialog_ewaybill" no-click-animation persistent transition="dialog-bottom-transition">
			<v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader style="display: flex;flex: 1;">E-Way Bill <v-spacer></v-spacer>
                        <v-btn icon @click="closeDialogWeb"><v-icon>close</v-icon></v-btn>
                    </v-subheader>
	        	</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height>
                    <!-- Generate E-Way bill JSON -->

                    <v-layout row wrap v-if="$parent.ewayBillFields && $parent.ewayBillFields.length">
                        <v-flex xs6 sm6 md6 pt-2 v-for="(field, index) in $parent.ewayBillFields[0].items" :key="index">
                            <div light-opacity-color>{{ field.fieldName }}</div>
                            <div v-if="field.fieldDataType == 'dateTime'">{{ field.fieldValue | moment("DD-MMM-YYYY") }}</div>
                            <div v-else>{{ field.fieldValue ? field.fieldValue : '-' }}</div>
                        </v-flex>
                    </v-layout>

                    <v-alert type="warning" :value="true" class="mt-4" v-if="$parent.ewayBillFields && $parent.ewayBillFields.length && $parent.ewayBillFields[0].items[0].fieldValue">E-Way bill already generated for this invoice.</v-alert>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
                    <v-layout row wrap>
                        <v-flex xs6 sm6 md6 center-align style="border-right: 1px #ddd solid;">
                            <v-btn small color="blue darken-1" flat @click="$parent.fn_editEwayInvoice($parent.ewayBillDetailSection.sectionId)">Edit Details</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6 center-align>
                            <v-btn small color="blue darken-1" flat @click="$parent.fn_downloadJSON($parent.ewayBillData, 'ewaybill')">Generate JSON</v-btn>
                        </v-flex>
                    </v-layout>
		        	<!-- <v-spacer></v-spacer> -->
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>

	export default{
		data(){
			return{
				dialog_ewaybill:false,
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_ewaybill = true;
			},
			closeDialogWeb: function () {
				this.dialog_ewaybill = false;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_ewaybill_confirmation.vue